import React from 'react';
import Lottie from 'react-lottie';
import { useTranslation } from 'react-i18next';

const Calendar = require('../resources/Calendar.json');

const lottieOptions = {
    loop: false,
    autoplay: true,
    animationData: Calendar,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
    }
};

const LinkExpired = (props) => {
    const { t } = useTranslation();

    return (<div className="seismic-engagement-viewer-content">
        <div className="seismic-engagement-viewer-link-expired">
            <div className="link-expired-img"><Lottie options={lottieOptions} /></div>
            <span className="link-expired-msg">{t('LIVE_SEND_VIEWER_LINK_EXPIRED')}</span>
            <span className="contact-owner">{t('LIVE_SEND_VIEWER_CONTACT_OWNER')}</span>
        </div>
        {props.children}
    </div>);
};

export default LinkExpired;
